import { Api } from '@/services/Api'
import store from "@/store/index"
const momentTz = require('moment-timezone')

export default {
  getPlantDeviceList (level) {
    return Api().get(`/api/v2/plant-analytics/${level}`)
  },
  getPlantData(param) {
    return Api().post('/api/v2/plant-analytics/data', param)
  },
  getPlantTableData(param) {
    return Api().post('/api/v2/plant-analytics/table', param)
  },
  downloadPlantTableData(key) {
    return Api().request({
      url: '/api/v2/plant-analytics/download/' + key, // your url
      method: 'GET',
      responseType: 'blob', // important
      timeout: 100000
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      const tz = store.getters.getActivePlantInfo('timezone')
      link.href = url
      link.setAttribute('download', `analytics-${momentTz().tz(tz).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`) // or any other extension
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    })
  },
  insertTemplates(param) {
    return Api().post(`api/v2/plant-analytics/template`, param)
  },
  fetchTemplate(userId) {
    return Api().get(`api/v2/plant-analytics/template/${userId}`)
  },
  deleteTemplate(id) {
    return Api().delete(`api/v2/plant-analytics/template/${id}`)
  },
  fetchParameterOrder(userId) {
    return Api().get(`api/v2/plant-analytics/order/${userId}`)
  }
}
